const ActionExtractBeforeAfter = [
    {
        value : 'before',
        text : 'Before'
    },
    {
        value : 'after',
        text : 'After'
    }
]

export default ActionExtractBeforeAfter;